import {RichText, InspectorControls} from "@wordpress/block-editor";
import { PanelBody, ToggleControl, SelectControl } from "@wordpress/components";

wp.blocks.registerBlockType('meetravel/section-title', {
    title : "Gradient Title",
    category : 'layout',
    icon : 'heading',
    attributes: {
        title: {
            type: 'string',
        },
        addCtaClass: {
            type: 'boolean',
            default: false,
        },
        textAlign: {
            type: 'string',
            default: 'left',
        },
    },

    edit(props){
        const { attributes, setAttributes } = props;
        const { title, addCtaClass, textAlign } = attributes;

        function updateTextAttribute(attr, value) {
            setAttributes({ [attr]: value });
        }

        return (
            <>
                <InspectorControls>
                    <PanelBody title="Opzioni Titolo" initialOpen={true}>
                        <ToggleControl
                            label="Aggiungi classe 'cta-section-title'"
                            checked={addCtaClass}
                            onChange={(value) => setAttributes({ addCtaClass: value })}
                        />
                        <SelectControl
                            label="Allineamento Testo"
                            value={textAlign}
                            options={[
                                { label: "Sinistra", value: "left" },
                                { label: "Centro", value: "center" },
                                { label: "Destra", value: "right" },
                            ]}
                            onChange={(value) => setAttributes({ textAlign: value })}
                        />
                    </PanelBody>
                </InspectorControls>
                <RichText
                    tagName="h2"
                    className={`section-title ${addCtaClass ? 'cta-section-title' : ''}`}
                    style={{ textAlign: textAlign }}
                    value={title}
                    onChange={(value) => updateTextAttribute('title', value)}
                />
            </>
        )
    },

    save(props){
        const { attributes } = props;
        const { title, addCtaClass, textAlign } = attributes;

        return (
            <RichText.Content
                tagName="h2"
                className={`section-title ${addCtaClass ? 'cta-section-title' : ''}`}
                style={{ textAlign: textAlign }}
                value={title}
            />
        )
    },
})